// DeviceConfigFormModule/TabServer.js
import React from 'react';
import { Row, Col, Form, Input, Typography, Alert } from 'antd';
import { CloudServerOutlined } from '@ant-design/icons';

const { Text } = Typography;

const urlRules = [
    // Simple URL validator (https strongly recommended)
    {
        validator: (_, value) => {
            if (!value) return Promise.resolve();
            try {
                const u = new URL(value);
                return Promise.resolve();
            } catch {
                return Promise.reject(new Error('Invalid URL format'));
            }
        }
    }
];

const TabServer = () => (
    <>
        <Row style={{ marginBottom: 16 }}>
            <Col span={24}>
                <Alert
                    type="info"
                    showIcon
                    message="Server override"
                    description={
                        <>
                            <Text>
                                Define an alternative backend URL here to send to devices.
                                Leave it blank to use the main server.
                            </Text>
                        </>
                    }
                />
            </Col>
        </Row>

        <Row gutter={[16,16]}>
            <Col span={24}>
                <Form.Item
                    name="ServerOverrideUrl"
                    label={<><CloudServerOutlined style={{ marginRight: 6 }} />Backend server override URL</>}
                    tooltip="If set, devices will switch their API/WebSocket base to this URL."
                    rules={urlRules}
                >
                    <Input placeholder="https://dsync.lambdalogic.de" allowClear />
                </Form.Item>
            </Col>
        </Row>
    </>
);

export default TabServer;